import { render, staticRenderFns } from "./dev-box1.vue?vue&type=template&id=36a0eb3e&scoped=true&"
import script from "./dev-box1.vue?vue&type=script&lang=js&"
export * from "./dev-box1.vue?vue&type=script&lang=js&"
import style0 from "./dev-box1.vue?vue&type=style&index=0&id=36a0eb3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a0eb3e",
  null
  
)

export default component.exports